var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{attrs:{"layout":_vm.layout},on:{"update:layout":function($event){_vm.layout=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }